/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  ScrollView,
} from 'react-native';
import HTML from 'react-native-render-html';

import Header from '../../components/misc/Header';
import styles from '../../styles';
import { translate } from '../../locales/i18n';

class Legal extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Legal';
  }

  render() {
    const { history } = this.props;

    const html = translate('company_legal');

    return (
      <View
        style={styles.view.headed}
      >
        <Header
          name={translate('menu_legal')}
          hasCancel
          history={history}
        />

        <ScrollView
          style={{
            flex: 1,
            width: '85%',
            alignSelf: 'center',
          }}
        >
          <HTML
            source={{ html }}
          />
        </ScrollView>
      </View>
    );
  }
}

Legal.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

export default Legal;
